<template>
  <b-nav-item
    v-if="isPermitted('manageAppeals')"
    right
    :title="`İtirazlar (${count})`"
    @click="navToAppeal"
  >
    <feather-icon
      :badge="badge"
      badge-classes="bg-danger"
      class="text-body"
      icon="MessageCircleIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import {
  BNavItem,
} from 'bootstrap-vue'
import { getUserData, isPermitted } from '@/auth/utils'

export default {
  components: {
    BNavItem,
  },
  data() {
    return {
      badge: null,
      count: null,
    }
  },
  created() {
    this.userData = getUserData()
  },
  mounted() {
    this.$root.$on('appeal_count', count => {
      this.count = count
      this.badge = count > 100 ? '!' : count
    })
  },
  beforeDestroy() {
    this.$root.$off('appeal_count')
  },
  methods: {
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    navToAppeal() {
      if (this.$route.path !== '/appeals') this.$router.push({ name: 'appeals' })
    },
  },
}
</script>

<style>

</style>
